import React from "react";
import { graphql, useFragment } from "react-relay";
import { notEmpty } from "../../../utils";
import { RoutineOccasionDescriptionContent_Routine$key } from "./__generated__/RoutineOccasionDescriptionContent_Routine.graphql";
import { DescriptionContentMedia } from "./DescriptionContentMedia";
import { DescriptionContentFiles } from "./DescriptionContentFiles";
import { DescriptionContentDescription } from "./DescriptionContentDescription";
import { DescriptionContentContainer } from "./DescriptionContentContainer";

export function RoutineOccasionDescriptionContent(props: {
  routine: RoutineOccasionDescriptionContent_Routine$key;
  hideOrg?: boolean;
}) {
  const routine = useFragment(
    graphql`
      fragment RoutineOccasionDescriptionContent_Routine on Routine {
        descriptionImages {
          ...DescriptionContentMedia_Media
        }
        description
        descriptionFiles {
          ...DescriptionContentFiles_files
        }
      }
    `,
    props.routine
  );

  return (
    <DescriptionContentContainer
      description={
        <DescriptionContentDescription
          description={routine.description ?? ""}
        />
      }
      media={
        <DescriptionContentMedia
          media={routine.descriptionImages.filter(notEmpty)}
        />
      }
      files={
        <DescriptionContentFiles
          files={routine.descriptionFiles}
          hideOrg={props.hideOrg}
        />
      }
    />
  );
}
